import * as z from '@exact-magic/validation';

export const UserLogin = z.object({
  email: z.email(),
  password: z.password(),
  remember: z.boolean().default(false),
});
export type UserLogin = z.input<typeof UserLogin>;
